import { Head, router } from "@inertiajs/react"
import { useState } from "react"

import HeadingSmall from "@/components/heading-small"
import { Switch } from "@/components/ui/switch"
import AppLayout from "@/layouts/app-layout"
import SettingsLayout from "@/layouts/settings/layout"
import { settingsNotificationsPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [{ title: "Settings", href: "/settings" }]

interface NotificationItem {
  key: string
  label: string
  description: string
  enabled: boolean
}

export default function Notifications({
  notifications,
}: {
  notifications: NotificationItem[]
}) {
  const [settings, setSettings] = useState<Record<string, boolean>>(() =>
    Object.fromEntries(notifications.map((n) => [n.key, n.enabled])),
  )

  function toggle(key: string) {
    const next = !settings[key]
    setSettings((prev) => ({ ...prev, [key]: next }))
    router.patch(
      settingsNotificationsPath(),
      { notifications: { [key]: next } },
      { preserveState: true, preserveScroll: true },
    )
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Notifications" />

      <SettingsLayout>
        <div className="space-y-6">
          <HeadingSmall
            title="Notifications"
            description="All notifications appear in-app. Choose which ones also send you an email."
          />

          <div>
            {notifications.map((event) => (
              <div
                key={event.key}
                className="flex items-center justify-between border-b py-4 last:border-0"
              >
                <div>
                  <p className="text-sm font-medium">{event.label}</p>
                  <p className="text-muted-foreground mt-1 text-sm">
                    {event.description}
                  </p>
                </div>
                <Switch
                  checked={settings[event.key]}
                  onCheckedChange={() => toggle(event.key)}
                />
              </div>
            ))}
          </div>
        </div>
      </SettingsLayout>
    </AppLayout>
  )
}
